function Notification() {
  return (
    <div>Hi, I will notify you</div>
  );
}

export default Notification;